<script lang="ts">
  import { onMount } from 'svelte';
  import { t } from '../lib/i18n';
  
  // State
  let debugModeEnabled = false;
  let maxLogsCount = 100;
  
  // Load settings
  onMount(() => {
    debugModeEnabled = localStorage.getItem('apiLoggerDebug') === 'true';
    const storedMaxLogs = localStorage.getItem('apiLoggerMaxLogs');
    maxLogsCount = storedMaxLogs ? parseInt(storedMaxLogs, 10) : 100;
  });
  
  // Toggle debug mode
  function toggleDebugMode() {
    debugModeEnabled = !debugModeEnabled;
    localStorage.setItem('apiLoggerDebug', debugModeEnabled.toString());
  }
  
  // Update max logs count
  function updateMaxLogs() {
    localStorage.setItem('apiLoggerMaxLogs', maxLogsCount.toString());
  }
</script>

<div class="api-logger-settings">
  <h6 class="mb-3">{t('API Logger Settings')}</h6>
  
  <div class="mb-3">
    <div class="form-check form-switch">
      <input 
        class="form-check-input" 
        type="checkbox" 
        id="debugMode" 
        bind:checked={debugModeEnabled}
        on:change={toggleDebugMode}
      >
      <label class="form-check-label" for="debugMode">
        {t('Enable ID Debug Logging')}
      </label>
    </div>
    <div class="form-text small">
      {t('When enabled, logs ID conversion operations. This may generate a lot of logs.')}
    </div>
  </div>
  
  <div class="mb-3">
    <label for="maxLogs" class="form-label">
      {t('Maximum Log Count')}
    </label>
    <div class="input-group input-group-sm">
      <input 
        type="number" 
        class="form-control" 
        id="maxLogs" 
        bind:value={maxLogsCount}
        min="10" 
        max="1000" 
        step="10"
      >
      <button 
        class="btn btn-outline-secondary" 
        type="button"
        on:click={updateMaxLogs}
      >
        {t('Update')}
      </button>
    </div>
    <div class="form-text small">
      {t('Maximum number of API logs to keep in memory.')}
    </div>
  </div>
</div>